import React from 'react'

// core components
import AutoCompleteDropdown from 'components/CustomDropdown/AutoCompleteDropdown'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

//wrapper specific, each dropdown needs a specific one
import { dictDepartments as dictData } from '../../queries/getDataForDropdowns'

// props here holds the classes and pass it down
const namePlaceholder = props => (
  <Query query={dictData} variables={{ companyId: props.companyId }} errorPolicy="all" fetchPolicy="network-only">
    {({ loading, error, data }) => {
      // console.log(props)
      if (error) return <p>Database connection error</p>
      if (loading) {
        return <p>Loading...</p>
      } else {
        // console.log('namePlaceholder - data is ready')
        // console.log(props)
        const { helperText = 'Choose a department ...', labelText = '', ...rest } = props
        // a few thing expected in props
        // 1) helperText, labelText - if not set we provide default which depends on what dropdown data we feed in
        // 2) id, order and onClick - used to provide state to caller
        // 3) rest - styling information d=>({...d, label:d.name})
        return (
          <AutoCompleteDropdown
            options={data.departments.map(d => ({ id:d.id, value:d.id, label: d.name }))}
            placeholder={helperText}
            labelText={labelText}
            {...rest}
          />
        )
      }
    }}
  </Query>
)

namePlaceholder.propTypes = {
  // classes: PropTypes.object.isRequired
}

export default graphql(dictData)(namePlaceholder)
